interface FinalCTAProps {
  onReserveClick: () => void;
}

export default function FinalCTA({ onReserveClick }: FinalCTAProps) {
  return (
    <section className="py-24 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/95deccefcb79e1decee38f2979b8f4c4.jpg" 
          alt="Moving totes" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-gray-900/70 to-gray-900/80"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">Move Without Cardboard</h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
          Reserve your reusable moving totes today and make your move easier.
        </p>
        <button onClick={onReserveClick} className="bg-yellow-400 text-gray-900 px-10 py-5 rounded-lg font-bold text-xl hover:bg-yellow-500 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer">
          Check Availability
        </button>
      </div>
    </section>
  );
}
